import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import AdminLogin from "pages/admin-login";
import DashboardOverview from "pages/dashboard-overview";
import ClientManagement from "pages/client-management";
import AddEditClientProfile from "pages/add-edit-client-profile";
import SubscriptionManagement from "pages/subscription-management";
import AdminAccountManagement from "pages/admin-account-management";
import TrainersManagment from "pages/trainers-managment";
import AddEditTrainerProfile from "pages/add-edit-trainer-profile";
import { LanguageProvider, useLanguage } from "./LanguageContext"; // Adjust the import path
import Layout from "./layout/Layout"; // Adjust the import path
import DepartmentsManagment from "pages/departments-managment";
import AddEditDepartmentProfile from "pages/add-edit-department-profile";
import PublicLandingPage from "pages/public-landing-page";
import ContactManagment from "pages/contact-user-managment";

const Routes = () => {
  const { direction } = useLanguage();
  const [isOpen, setIsOpen] = useState(false); // State to manage sidebar open/close

  useEffect(() => {
    document.documentElement.dir = direction; // Set the document direction
  }, [direction]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<PublicLandingPage />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route
            path="/dashboard-overview"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <DashboardOverview />
              </Layout>
            }
          />
          <Route
            path="/client-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <ClientManagement />
              </Layout>
            }
          />
          <Route
            path="/trainers"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <TrainersManagment />
              </Layout>
            }
          />
          <Route
            path="/add-edit-client-profile"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AddEditClientProfile />
              </Layout>
            }
          />
          <Route
            path="/add-edit-trainer-profile"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AddEditTrainerProfile />
              </Layout>
            }
          />
          <Route
            path="/subscription-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <SubscriptionManagement />
              </Layout>
            }
          />
          <Route
            path="/admin-account-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AdminAccountManagement />
              </Layout>
            }
          />
          <Route
            path="/departments"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <DepartmentsManagment />
              </Layout>
            }
          />
          <Route
            path="/add-edit-department-profile"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AddEditDepartmentProfile />
              </Layout>
            }
          />

             <Route
            path="/contact_us"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <ContactManagment />
              </Layout>
            }
          />
          
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

const App = () => (
  <LanguageProvider>
    <Routes />
  </LanguageProvider>
);

export default App;
